import { useFormikContext } from 'formik';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../atoms/Button';
import EmailField from '../../../fields/EmailField';
import PasswordField from '../../../fields/PasswordField';
import Modal from '../../../atoms/Modal';
import ForgotPassword from '../SignIn/ForgotPassword';

const WelcomeBack = ({
  returningCustomer,
  onDifferentCustomer,
}: {
  returningCustomer: { firstName: string; lastName: string; email: string };
  onDifferentCustomer: () => void;
}) => {
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const { submitForm, isSubmitting } = useFormikContext();

  const toggleForgotPassword = () => {
    setShowForgotPasswordModal(!showForgotPasswordModal);
  };

  const testIdPrefix = 'login';

  return (
    <>
      {showForgotPasswordModal && (
        <Modal>
          <ForgotPassword onClose={toggleForgotPassword} />
        </Modal>
      )}
      <div className="form__row">
        <div className="form__field-container">
          <EmailField testIdPrefix={testIdPrefix} />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <PasswordField testIdPrefix={testIdPrefix} type="signIn" />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <span
            className="auth-form__forgot-password"
            data-test-id="login-forgot-password"
            onClick={toggleForgotPassword}
          >
            <FormattedMessage id="auth.options.signIn.forgotPassword" />
          </span>
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <Button
            type="button"
            onClick={() => submitForm()}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            data-test-id="login-submit"
          >
            <FormattedMessage id="auth.options.signIn.label" />
          </Button>
        </div>
      </div>
      <div className="form__row auth-form__different-account" onClick={onDifferentCustomer}>
        <div className="form__field-container">
          <FormattedMessage id="auth.returningCustomer.differentAccount" values={returningCustomer} />
        </div>
      </div>
    </>
  );
};

export default WelcomeBack;
